import { useEffect, useState } from 'react';

export interface AvatarProps {
  /** Uploaded photo, when set; falls back to initials otherwise. */
  photoUrl?: string;
  /** Fallback text (already computed initials, e.g. "SC"). */
  initials: string;
  /** Diameter in pixels. */
  size?: number;
  className?: string;
}

/**
 * Circular photo-or-initials avatar (design-system primitive, no domain
 * knowledge, no upload logic). `AvatarUploadField` in `components/common/`
 * layers the click-to-upload affordance on top of this for editable contexts.
 */
export function Avatar({ photoUrl, initials, size = 64, className = '' }: AvatarProps) {
  const style = { width: size, height: size };
  const [failed, setFailed] = useState(false);

  // A later re-render with a fresh photoUrl (e.g. after a re-upload
  // following a previous load failure) should get a clean retry.
  useEffect(() => {
    setFailed(false);
  }, [photoUrl]);

  if (photoUrl && !failed) {
    return (
      <img
        src={photoUrl}
        alt=""
        style={style}
        className={`rounded-full object-cover ${className}`.trim()}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      style={style}
      className={`flex items-center justify-center rounded-full bg-navy font-bold text-white ${className}`.trim()}
    >
      {initials || '?'}
    </div>
  );
}
